export default __webpack_public_path__ + "static/media/piramid.804daff9.svg";